// packages import
import CloseIcon from '@mui/icons-material/Close'
import FilterListIcon from '@mui/icons-material/FilterList'
import { Box, Button, Drawer, IconButton, useMediaQuery } from '@mui/material'
import { FC, MouseEvent, useState } from 'react'
// component import
import { CasesFilter } from './CasesFilter'
// others
import { FilterDrawerProps } from '../../interfaceTypes'

type Anchor = 'right'

type DrawerMode = 'full' | 'extras'

type Props = FilterDrawerProps & { mode?: DrawerMode }

export const FilterDrawer: FC<Props> = ({ casesLength, sortByUser, showClient = true, loading, mode = 'full', refetch, fetchAllCases }) => {
  const [toggleDrawerState, setToggleDrawerState] = useState(false)
  const mediumViewport = useMediaQuery('(max-width:1138)')

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation()
    event.preventDefault()
    setToggleDrawerState(!toggleDrawerState)
  }
  const toggleDrawer = (anchor: Anchor, open: boolean) => (event: KeyboardEvent | MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as KeyboardEvent).key === 'Tab' || (event as KeyboardEvent).key === 'Shift')
    ) {
      return
    }

    setToggleDrawerState(!toggleDrawerState)
  }

  const isExtras = mode === 'extras'

  const trigger = mediumViewport ? (
    <Button type="button" variant="outlined" size="small" onClick={handleClick}>
      More filters
    </Button>
  ) : (
    <IconButton type="button" onClick={handleClick} title="More Filters">
      <FilterListIcon color="primary" />
    </IconButton>
  )

  // For "extras" mode, position inline with filters (not absolute)
  // For "full" mode (small viewport), use absolute positioning
  const containerStyles = isExtras
    ? { position: 'relative' as const } // Inline positioning for extras mode
    : { position: 'absolute' as const, top: '-42px', right: 30 } // Absolute for small viewport

  return (
    <Box {...containerStyles}>
      {trigger}

      <Drawer anchor="right" open={toggleDrawerState} onClose={toggleDrawer('right', false)}>
        <Box position="absolute" right="5px" top="5px">
          <IconButton onClick={toggleDrawer('right', false)}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box width="300px" marginTop="50px" padding="10px 18px">
          <CasesFilter
            casesLength={casesLength!}
            sortByUser={sortByUser}
            showSearch={!isExtras}
            showSortBy={!isExtras}
            showLawType
            showSortDir={!isExtras}
            showClient={!isExtras && showClient}
            showOffice
            showSortByUser
            showExport
            showReset
            loading={loading}
            refetch={refetch}
            fetchAllCases={fetchAllCases}
          />
        </Box>
      </Drawer>
    </Box>
  )
}
